import { Configuration, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { msalConfig } from "./authConfig";
import "./index.css";
const msalInstance = new PublicClientApplication(msalConfig as Configuration);

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement,
);
root.render(
	<div>
		<MsalProvider instance={msalInstance}>
			<App />
		</MsalProvider>
	</div>
);

